import React from "react";
import { connect } from "react-redux";
import { Container, Button, Input } from "@material-ui/core";
import * as actionsAdjuntarArchivo from "../../../actions/adjuntarArchivo";
import * as actionsVentanaDialogo from "../../../actions/ventanaDialogo";
import * as actionsPresentacion from "../../../actions/nuevaPresentacion";
import styles from "./styles";
import uploadIcono from "../../../assets/iconos/upload-icon.png";
import AddIcon from "@material-ui/icons/Add";
import DocumentIcon from "@material-ui/icons/DescriptionOutlined";

const internacionesMasivo = (props) => {
    const extensionesAceptadas = ".jpg,jpeg,.png,.pdf";

    const filtrarArchivosPorExtension = (archivos) => {
        const archivosFiltrados = archivos.filter((archivo) => {
            const extensiones = extensionesAceptadas.split(",");
            let arcValido = false;

            for (let i = 0; i < extensiones.length; i++) {
                const extension = extensiones[i];

                if (
                    archivo.name.toLowerCase().endsWith(extension) &&
                    archivo.name.match(/^\d+(_|-)/)
                ) {
                    const nroInternacion = archivo.name.match(/^\d+(_)/)
                        ? archivo.name.split("_")[0]
                        : archivo.name.split("-")[0];
                    const internacion = props.buscarInternacion(nroInternacion);
                    if (
                        !internacion ||
                        (internacion &&
                            !internacion.detalles.some(
                                (arch) =>
                                    arch.nombreArchivo === archivo.name &&
                                    !arch.bajaLogica
                            ))
                    ) {
                        arcValido = true;
                        break;
                    }
                }
            }

            return arcValido;
        });

        return archivosFiltrados;
    };

    const cerrarVetana = () => {
        props.actualizarAtriutoVentanaDialogo({
            estaVisible: false,
        });
    };

    const cargarArchivosInternacionesMasivo = (archivos) => {
        const archivosFiltrados = filtrarArchivosPorExtension(archivos);

        if (archivosFiltrados.length > 0) {
            props.cancelarCargaMasiva().finally(() => {
                props.subiendoInternacionesMasivo(true);
                props.subirArchivosInternacionesMasivo(archivosFiltrados);
            });
        } else {
            const ventanaConfig = {
                estaVisible: true,
                titulo: "Error al procesar archivos",
                mensaje:
                `No se procesó ninguno de los archivos seleccionados, ya que no cumplen con el formato de nombre de archivo requerido: [${props.tipoPresentacionSeleccionada===3?'DNISocio':'NroInternación'}_textolibre] o [${props.tipoPresentacionSeleccionada===3?'DNISocio':'NroInternación'}-textolibre], las extensiones soportadas  [*.jpg,*.jpeg,*.png,*.pdf] o se encuentra repetido`,
                esAlerta: true,
                clickAceptar: cerrarVetana,
            };

            props.actualizarAtriutoVentanaDialogo(ventanaConfig);
        }

        document.getElementById("cargaMasivaButton").value = null;
    };

    const classes = styles();

    if (props.soloVista) {
        return null;
    }

    return (
        <Container disableGutters={true} className={classes.container}>
            <Button
                variant="outlined"
                className={classes.btnAdjuntar}
                disabled={props.deshabilitarNueva || props.soloVista}
                onClick={props.deshabilitarHandle}
            >
                <div className={classes.iconoUpload}>
                    <AddIcon fontSize="small" htmlColor="#BDBDBD" />
                </div>
                Nuevo socio
            </Button>
            <Button
                variant="outlined"
                component="label"
                className={classes.btnAdjuntar}
                disabled={props.deshabilitado}
            >
                <Input
                    id="cargaMasivaButton"
                    type="file"
                    disabled={props.deshabilitado}
                    onChange={(event) =>
                        cargarArchivosInternacionesMasivo([
                            ...event.target.files,
                        ])
                    }
                    inputProps={{
                        accept: extensionesAceptadas,
                        multiple: true,
                        hidden: true,
                    }}
                />
                <img
                    src={uploadIcono}
                    alt="Subir archivo"
                    className={classes.iconoUpload}
                />
                Carga masiva
            </Button>
        </Container>
    );
};

const mapStateToProps = (state) => ({
    soloVista: state.nuevaPresentacionReducer.soloVista,
    tipoPresentacionSeleccionada: state.nuevaPresentacionReducer.tipoPresentacionSeleccionada
});

const actionCreators = {
    subiendoInternacionesMasivo:
        actionsAdjuntarArchivo.subiendoInternacionesMasivo,
    subirArchivosInternacionesMasivo:
        actionsAdjuntarArchivo.subirArchivosInternacionesMasivo,
    cancelarCargaMasiva: actionsAdjuntarArchivo.cancelarCargaMasiva,
    actualizarAtriutoVentanaDialogo:
        actionsVentanaDialogo.actualizarAtriutoVentanaDialogo,
    buscarInternacion: actionsPresentacion.buscarInternacion,
};

export default connect(mapStateToProps, actionCreators)(internacionesMasivo);
